/**
 * The UI's copy of the flags it gates on, because this bundle cannot import from core. The source of
 * truth is FeatureFlagName in packages/core/domain/feature-flag. Backend-only flags are deliberately
 * absent — they are declared in the `backendOnly` option on physna/feature-flag-declarations, which
 * fails lint on a flag that is in neither place, and on a flag here that core no longer declares.
 */
export enum FeatureFlagName {
  SUITABLE_SUBSTITUTES = 'suitable_substitutes',
  PART_FINDER_REPORTS = 'part_finder_reports',
  PART_FINDER_THUMBNAILS = 'part_finder_thumbnails',
  PART_FINDER_DOCUMENTS = 'part_finder_documents',
  SUPPLEMENTAL_ASSETS = 'supplemental_assets',
  CRITICAL_GEOMETRY = 'critical_geometry',
  METADATA_SEARCH_UI = 'metadata_search_ui',
  USAGE_ANALYTICS = 'usage_analytics',
  IMAGE_SEARCH_CROPPING_DISABLED = 'image_search_cropping_disabled',
  SEMANTIC_DESCRIPTION_GENERATION = 'semantic_description_generation',
  SEMANTIC_DESCRIPTION_VISIBILITY = 'semantic_description_visibility',
  COMPARISON_HEATMAP = 'comparison_heatmap',
  TAXONOMY = 'taxonomy',
  TAXONOMY_AI_CLASSIFICATION = 'taxonomy_ai_classification',
  USD_INGEST = 'usd_ingest',
  SCENE_INGESTION = 'scene_ingestion',
}
